/**
 * Combina filas de getServicesByFile (Core, con order anidado)
 * con campos adicionales de la query Sales legacy (objProducto, etc.).
 */
export function mergeServiceRowsWithOrder(
  coreServices: any[],
  legacyServices: any[] | null | undefined
): any[] {
  const legacyById = new Map(
    (legacyServices ?? []).map((service) => [service.id, service])
  );

  return coreServices.map((core) => {
    const legacy = legacyById.get(core.id) ?? {};
    return {
      ...legacy,
      ...core,
      order: core.order ?? null
    };
  });
}

export function enrichServicesWithFileMeta(
  services: any[],
  fileMeta: {
    fileNumber?: string;
    fileName?: string;
    fileExtend?: string;
    dateRange?: string;
    fileDisplayState?: string | null;
  }
): any[] {
  return services.map((service) => ({
    ...service,
    fileNumber: fileMeta.fileNumber ?? service.fileNumber,
    fileName: fileMeta.fileName ?? service.fileName,
    fileExtend: fileMeta.fileExtend ?? service.fileExtend,
    dateRange: fileMeta.dateRange ?? service.dateRange,
    fileDisplayState: fileMeta.fileDisplayState ?? service.fileDisplayState
  }));
}
